import React, {useState, useEffect} from 'react';
import {
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow} from '@mui/material';
import {createTheme} from '@mui/material/styles';
import AssociationService from '../../services/association.service';
import Table from '@mui/material/Table';
import {Link} from 'react-router-dom';
import Button from "@mui/material/Button";
import VOCSETLayout from '../../views/VOCSETLayout';
import {dropdownItems} from '../../views/dropdownItems';
import {MoonLoader} from "react-spinners";
import {Association} from "../../types/APITypes";


createTheme();
const AssociationDashboard = () => {
    const [associations, setAssociations] = useState<Association[]>([]);
    const [error, setError] = useState<string>('');
    const [open, setOpen] = useState(true);
    const [loading, setLoading] = useState(true);

    const resize = () => {
        setOpen(window.innerWidth >= 760);
    };
    const handleDrawerToggle = () => {
        setOpen(!open);
    };
    useEffect(() => {
        // @ts-ignore
        window.addEventListener('resize', resize.bind(this));
        resize();
    }, []);
    useEffect(() => {
        window.addEventListener('error', e => {
            if (e.message === 'ResizeObserver loop limit exceeded' || e.message === 'Script error.') {
                const resizeObserverErrDiv = document.getElementById(
                    'webpack-dev-server-client-overlay-div'
                )
                const resizeObserverErr = document.getElementById(
                    'webpack-dev-server-client-overlay'
                )
                if (resizeObserverErr) {
                    resizeObserverErr.setAttribute('style', 'display: none');
                }
                if (resizeObserverErrDiv) {
                    resizeObserverErrDiv.setAttribute('style', 'display: none');
                }
            }
        })
    }, [])

    useEffect(() => {
        AssociationService.getAssociations(true)
            .then((fetchedData) => {
                if (!fetchedData){
                    setError('No associations available.');
                }
                setLoading(false)
                setAssociations(fetchedData);
            })
            .catch((error) => {
                // @ts-ignore
                console.error('Error fetching associations:', error.response ? error.response.data : error);
                setError(error?.response?.data?.result?.[0]?.message || 'Error fetching associations. Please try again.');
            });
    }, []);

    return (
        <div>
            <VOCSETLayout dropdownItems={dropdownItems}>
                {loading ? (
                    <MoonLoader color="#282c34"/>
                ) : (
                    associations.length === 0 ? (
                        <p>No associations found.</p>
                    ) : (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Principal</TableCell>
                                        <TableCell>Relationship</TableCell>
                                        <TableCell>Associate</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {associations.map((asc) => (
                                        <TableRow key={asc.id}>
                                            <TableCell>{asc.principalShortName}</TableCell>
                                            <TableCell>{asc.associationTypeName}</TableCell>
                                            <TableCell>{asc.associateShortName}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )
                )}
            </VOCSETLayout>
        </div>
    );
}

export default AssociationDashboard;
